import { lazy } from 'react'

import { CommunityRoutes } from './routes'

const CommunityProvider = lazy(() => import('@space-shell/pages/community'))

export const CommunityRouter = () => {
  return (
    <CommunityProvider>
      <CommunityRoutes />
    </CommunityProvider>
  )
}
